import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Row, DatePicker, Switch, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Form } from '@ant-design/compatible';
import checkPermission from '../../../../components/Authorization/Util';
import UserContext from '../../../layout/UserContext';
import OldImageUploader from '../../../../firebase/OldImageUploader';
import { useTranslation } from 'react-i18next';

const General = ({ formData, form, submit }) => {
  const { t } = useTranslation(); 
  const [imageList, setImageList] = useState([]);

  useEffect(() => {
    form.setFieldsValue({
      image: imageList,
    });
  }, [imageList])

  useEffect(() => {
    if (formData?.data?.image) {
      setImageList([formData.data.image])
    } else {
      setImageList([]);
    }
  }, [formData])

  const { getFieldDecorator } = form;
  const value = useContext(UserContext);

  const disable = !checkPermission(value, 'appcms', 'write');

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    (<div>
      <Row>
        <Col span={13}>
          <Row>
            <Col span={24}>
              <Card bordered={false}>
                <Form.Item label={t('appCms.news.date')}>
                  {getFieldDecorator('date', {
                    rules: [
                      {
                        required: true,
                        message: t('appCms.news.dateRequired'),
                      },
                    ],
                    initialValue:
                      formData && formData.data.date
                        ? moment(formData.data.date, 'YYYY-MM-DD')
                        : undefined,
                  })(<DatePicker disabled={disable} />)}
                </Form.Item>

                <Form.Item
                  label={
                    <span>
                      {t('appCms.news.published')}&nbsp;
                      <Tooltip title={t('appCms.news.publishedTooltip')}>
                        <InfoCircleOutlined />
                      </Tooltip>
                    </span>
                  }
                >
                  {getFieldDecorator('published', {
                    valuePropName: 'checked',
                    initialValue:
                      formData && formData.data.published
                        ? formData.data.published
                        : undefined,
                  })(<Switch disabled={disable} />)}
                </Form.Item>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col span={11}>
          <Card bordered={false}>
            <Form.Item
              wrapperCol={{ xs: { span: 24 } }}
              style={{ display: 'flex' }}
            >
              {getFieldDecorator('image', {
                valuePropName: 'file',
              })(
                <Card title={t('appCms.news.image')}>
                  <Row justify="center">
                    <div className="clearfix">
                      <OldImageUploader
                        disabledAdd={!checkPermission(value, 'appcms', 'write')}
                        setFileList={setImageList}
                        fileList={imageList}
                        maxCount={1}
                        storageFolder='news-images'
                      />
                    </div>
                  </Row>
                </Card>,
              )}
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </div>)
  );
};

General.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object,
  formData: PropTypes.object,
  submit: PropTypes.func,
};

General.contextType = UserContext;

function mapStateToProps({ objectNumReducer }) {
  const { objectNumList } = objectNumReducer;
  return {
    objectNumList,
  };
}

export default connect(mapStateToProps, {})(General);
